import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogDraggableHeaderComponent } from './dialog-draggable-header.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    MatToolbarModule,
    MatIconModule
  ],
  exports: [DialogDraggableHeaderComponent],
  declarations: [DialogDraggableHeaderComponent]
})
export class DialogDraggableHeaderModule { }
